import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import TextInput from "@builder/components/general/TextInput";
//import UnitInput from "@builder/components/general/UnitInput";
import { getPaymentDetails, getSelectedNodeText } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import "./style.scss";
import Toggle from "@builder/components/general/Toggle";
import SelectInput from "@builder/components/general/SelectInput";
import EditableInfo from "../../EditableInfo";
import OliverText, { TextType } from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";

const Payment = ({ parent, excluded }: EditableProps) => {
    const dispatch = useAppDispatch();
    const paymentDetails = useAppSelector(getPaymentDetails);
    const { t } = useTranslation();
    // const pages = useAppSelector(getPages);

    let connectionTypeElem = null;
    if (!excluded || !excluded.includes("connection")) {
        const connectionType = paymentDetails?.terminal;
        const connectionTypeOptions = {
            cloud: "Cloud",
            bluetooth: "Bluetooth / On device"
        };
        const connectionTypeCallback = (value: string) => {
            dispatch(updateNodeProperty({ propertyPath: ["paymentDetails", "terminal"], value: value }));
        };
        connectionTypeElem = (
            <SelectInput
                layout="column"
                title="Connection type"
                options={connectionTypeOptions}
                value={connectionType}
                callback={connectionTypeCallback}
            />
        );
    }

    //Button name
    const paymentButtonName = useAppSelector(getSelectedNodeText) || "";
    const paymentButtonNameCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["text"], value: value }));
    };

    // //Add Fee
    // const addedFee = paymentDetails?.addedFee;
    // const addedFeeCallback = (value: string, unit: string) => {
    //     dispatch(updateNodeProperty({ propertyPath: ["paymentDetails", "addedFee"], value: { value, type: unit } }));
    // };

    // //Discount
    // const addedDiscount = paymentDetails?.addedDiscount;
    // const addedDiscountCallback = (value: string, unit: string) => {
    //     dispatch(updateNodeProperty({ propertyPath: ["paymentDetails", "addedDiscount"], value: { value, type: unit } }));
    // };

    let cashRoundingElem = null;
    let changeCalculatorElem = null;
    const isCashPayment = !excluded || !excluded.includes("cash");
    const isCustomPayment = !excluded || !excluded.includes("custom");

    if (isCashPayment) {
        //Cash rounding
        const cashRounding = paymentDetails?.cashRounding;
        const cashRoundingOptions = {
            "": "Do not round",
            "0.05": "Round to nearest 0.05",
            "0.10": "Round to nearest 0.10",
            "0.25": "Round to nearest 0.25",
            "0.50": "Round to nearest 0.50",
            "1.00": "Round to nearest 1.00"
        };
        const cashRoundingCallback = (value: string) => {
            dispatch(updateNodeProperty({ propertyPath: ["paymentDetails", "cashRounding"], value }));
        };
        cashRoundingElem = (
            <SelectInput
                title="Cash rounding"
                layout="column"
                value={cashRounding || ""}
                options={cashRoundingOptions}
                callback={cashRoundingCallback}
            />
        );

        //Show change calculator
        const changeCalculator = paymentDetails?.changeCalculator;
        const changeCalculatorCallback = (checked: boolean) => {
            dispatch(updateNodeProperty({ propertyPath: ["paymentDetails", "changeCalculator"], value: checked }));
        };
        changeCalculatorElem = <Toggle label="Show change calculator" checked={!!changeCalculator} callback={changeCalculatorCallback} />;
    }

    // After payment page
    // const checkoutPage = paymentDetails?.checkoutCompletePage;
    // const pageNames = pages.reduce((acc: Record<string, string>, page) => {
    //     acc[page.name] = page.name;
    //     return acc;
    // }, {});

    // const checkoutCompleteCallback = (value: string) => {
    //     dispatch(updateNodeProperty({ propertyPath: ["paymentDetails", "checkoutCompletePage"], value }));
    // };

    // const checkoutCompleteSelector = (
    //     <SelectInput
    //         title="Checkout complete page"
    //         layout="column"
    //         value={checkoutPage || ""}
    //         options={pageNames}
    //         callback={checkoutCompleteCallback}
    //         noTranslate
    //     />
    // );

    return (
        <SidebarCollapse title="Payment" parent={parent}>
            {!excluded ||
                (!excluded.includes("custom") && (
                    <div className="custom-payment-info">
                        <OliverText size="xs" weight="semi-bold" text={t("editableInfo.customPaymentHeader")} />
                        <OliverText type={TextType.BODY_4} text={t("editableInfo.customPaymentBody")} />
                    </div>
                ))}
            {connectionTypeElem}
            <TextInput title="Payment name" value={paymentButtonName} placeholder="Card" callback={paymentButtonNameCallback} />
            {/* <UnitInput title="Add fee" value={addedFee?.value || ""} unit={addedFee?.type || "$"} mode="currency" callback={addedFeeCallback} />
            <UnitInput
                title="Add discount"
                value={addedDiscount?.value || ""}
                unit={addedDiscount?.type || "$"}
                mode="currency"
                callback={addedDiscountCallback}
            /> */}
            {/* {checkoutCompleteSelector} */}
            {isCashPayment && <div className="payment-button-divider"></div>}

            {!isCashPayment && !isCustomPayment && (
                <EditableInfo header="How do tips work?" body="Tips can be enabled for Final Pay in flow settings." />
            )}

            {cashRoundingElem}
            {changeCalculatorElem}
        </SidebarCollapse>
    );
};

export default Payment;
